export const VISIT_RATING_TYPE = 'VISIT_RATING_TYPE';

export const lastVisitedRatingTypeAction = ({ ratingType }) => ({
  type: VISIT_RATING_TYPE,
  payload: { ratingType },
});
